import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { useSelector } from '../../../../redux/store';

AcknowledgementIcon.propTypes = {
  row: PropTypes.object,
  overrideOrderId: PropTypes.string,
};

export default function AcknowledgementIcon({ row, overrideOrderId }) {
  const { id: orderId = '' } = useParams();
  const id = overrideOrderId || orderId;

  const { orderById } = useSelector((state) => state.orders || {});
  const { dateApproved = '' } = orderById[id] || {};
  const dateApprovedPlus24Hours = dayjs(dateApproved).add(24, 'hour').format('M-D-YY h:mm A');

  return (
    <div>
      <Tooltip
        PopperProps={{ disablePortal: false }}
        title={
          row?.approved === false
            ? ''
            : row?.statusUpdates?.length > 0
              ? row.statusUpdates[0]?.status === 'Unapproved'
                ? 'Unapproved'
                : 'Vendor Received'
              : row.vendorInfo?.sendsAcknowledgment
                ? `Confirmation expected by ${dateApprovedPlus24Hours} EST`
                : `No Acknowledgement Expected`
        }
        disableHoverListener={row?.deleted === true}
      >
        <IconButton disableRipple edge="end" sx={{ pl: 0, ml: 0 }}>
          <CheckCircleOutlineIcon
            sx={{ fontSize: '1.00rem' }}
            color={
              row?.statusUpdates?.length > 0 && row.statusUpdates[0]?.status !== 'Unapproved' ? 'secondary' : 'grey'
            }
          />
        </IconButton>
      </Tooltip>
    </div>
  );
}
